import Component from '../vendor/Component'

export default class MainProductGallery extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._galleryElement = this._elem.querySelector(".swiper")
  }

  mount() {
    this.setupListeners()
    this.initCarousel()
  }

  setupListeners() {
    this._elem.addEventListener('click', this.handleLightboxProxy.bind(this));
  }

  initCarousel() {
    if (this._galleryElement) {
      new window.swiper(this._galleryElement, {
        spaceBetween: 5,
        slidesPerView: 1.2,
        loop: false,
        breakpoints: {
          992: {
            slidesPerView: 1,
          }
        },
        navigation: {
          nextEl: '[data-main-product-gallery-el="next"]',
          prevEl: '[data-main-product-gallery-el="prev"]',
        },
        on: {
          afterInit: (swiper) => {
            swiper.el.classList.remove('loading');
          }
        },
      });
    }
  }

  handleLightboxProxy(e) {
    const proxy = e.target.closest('[data-lightbox-proxy]');

    if (!proxy) return;

    e.preventDefault();

    const target = this._elem.querySelector(`[data-lightbox-index="0"]`);

    target.click();
  }
}
